import { FC } from 'react';
import styled from './index.module.scss';
import Banner from '@/components/TradeIn/components/Banner';
import Introduce from '@/components/TradeIn/components/Introduce';
import SeriesTab from '@/components/TradeIn/components/SeriesTab';
import GetGift from '@/components/TradeIn/components/GetGift';
import ShopList from '@/components/TradeIn/components/ShopList';
import Conditions from '@/components/TradeIn/components/Conditions';

const TradeInCompoment: FC = ({}) => {
    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    body::-webkit-scrollbar {
                        width: 5px;
                    }
                    body::-webkit-scrollbar-thumb {
                        border-radius: 5px;
                        background: #ccc;
                    }
                `}
            </style>
            <div className={`${styled.TradeInCompoment}`}>
                <Banner />
                <Introduce />
                <SeriesTab />
                <GetGift />
                <ShopList />
                <Conditions />
            </div>
        </>
    );
};

export default TradeInCompoment;
